import { render, staticRenderFns } from "./backButton.vue?vue&type=template&id=9c883366"
import script from "./backButton.ts?vue&type=script&lang=js&external"
export * from "./backButton.ts?vue&type=script&lang=js&external"
import style0 from "./backButton.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports